<footer class="p-3 bg-pmdf-bg-muted border-t border-pmdf-border">
  <p class="text-sm text-center text-pmdf-muted-70">
    <span class="font-bold">Nexus</span> • {{ versionLabel }} •
    <span class="font-family-pmdf-heading font-semibold">Polícia Militar do Distrito Federal</span>
  </p>
</footer>
